module.exports = __webpack_public_path__ + "static/media/es-flag.ae9b0e11.svg";